import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import CategoriesSection from './components/CategoriesSection';
import FeaturedSection from './components/FeaturedSection';
import HotTopicsSection from './components/HotTopicsSection';
import ReviewsSection from './components/ReviewsSection';
import CTASection from './components/CTASection';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '51黑料网是什么网站？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '51黑料网是中国领先的网红主播爆料与娱乐八卦资讯平台，致力于为广大网友提供真实、及时、深度的爆料内容，涵盖网红塌房、主播爆料、每日吃瓜、独家猛料等多个栏目。',
      },
    },
    {
      '@type': 'Question',
      name: '51黑料网的爆料内容可信吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '51黑料网所有内容均来源于网络及用户投稿，我们会对信息进行多渠道核实。但爆料内容仅供参考，建议读者保持理性判断，不造谣、不信谣、不传谣。',
      },
    },
    {
      '@type': 'Question',
      name: '51黑料网多久更新一次？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '51黑料网实行7×24小时不间断更新机制，确保用户能够第一时间获取最新的网红主播塌房内幕与娱乐八卦资讯。',
      },
    },
    {
      '@type': 'Question',
      name: '如何在51黑料网投稿爆料？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '欢迎通过51黑料网官方邮箱或社交媒体渠道向我们投稿爆料。我们承诺对爆料者信息严格保密，并对有价值的爆料进行核实后发布。',
      },
    },
  ],
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <TrendingSection />
        <CategoriesSection />
        <FeaturedSection />
        <HotTopicsSection />
        <ReviewsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}